import React from 'react';
import LazyLoad from '../shared/LazyLoad';

const UserSessionLoader = () => import(/* webpackChunkName: "lzUserSession" */ "./UserSession");
const LazyUserSession: React.FC = () => <LazyLoad componentLoader={UserSessionLoader} />;

// Only the authenticated route tree lives here now — public form routes are
// rendered above AuthContainer (see App/index.tsx) so they never require login.
const AppRoutes = () => <LazyUserSession />;


export default AppRoutes;
